let d3Array: typeof import("d3-array")

// Async load of D3 lib, in order to lower startup bundle load time
import(/* webpackChunkName: "d3-array" */ "d3-array")
  .then(importedFile => (d3Array = importedFile))
  .catch(error => {
    console.error("An error occurred while async loading d3", error)
  })

export function getQuantiles(values: number[], stepCount: number): number[] {
  let quantiles: number[] = []
  const step = 1 / stepCount
  for (let i = step; i < 1; i += step) {
    const quantile = d3Array.quantile(values, i)
    if (quantile !== undefined) {
      quantiles.push(quantile)
    }
  }
  quantiles.sort((v1, v2) => (v1 === v2 ? 0 : v1 < v2 ? -1 : 1))
  quantiles = quantiles.filter((q, index) => quantiles.indexOf(q) === index)
  return quantiles
}

export function mergeArrays(array1: any[], array2: any[]): any[] {
  return d3Array.merge([array1, array2])
}
